import { render, staticRenderFns } from "./surveyResult.vue?vue&type=template&id=67cc712b&"
import script from "./surveyResult.vue?vue&type=script&lang=js&"
export * from "./surveyResult.vue?vue&type=script&lang=js&"
import style0 from "./surveyResult.vue?vue&type=style&index=0&id=67cc712b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports